// Validation de format du numéro de TVA intracommunautaire, côté client.
// FR : "FR" + clé (2 caractères) + SIREN (9 chiffres) — on vérifie le format (l'existence est
// confirmée par la recherche Sirene). Non-FR : simple contrôle de format par préfixe pays (l'existence
// n'est pas vérifiée, cf. demande produit). Aucun appel réseau.

const VAT_PATTERNS: Record<string, RegExp> = {
    FR: /^FR[0-9A-Z]{2}[0-9]{9}$/,
    BE: /^BE0[0-9]{9}$/,
    DE: /^DE[0-9]{9}$/,
    ES: /^ES[0-9A-Z][0-9]{7}[0-9A-Z]$/,
    IT: /^IT[0-9]{11}$/,
    NL: /^NL[0-9]{9}B[0-9]{2}$/,
    LU: /^LU[0-9]{8}$/,
    PT: /^PT[0-9]{9}$/,
    IE: /^IE[0-9A-Z+*]{8,9}$/,
    GB: /^GB([0-9]{9}([0-9]{3})?|(HA|GD)[0-9]{3})$/,
};

// Repli générique pour les autres pays UE : 2 lettres + 2 à 13 caractères alphanumériques.
const GENERIC_EU_VAT = /^[A-Z]{2}[0-9A-Z]{2,13}$/;

/** Met en forme : majuscules, sans espaces ni points. */
export function normalizeVat(input: string | null | undefined): string {
    return (input ?? '').toUpperCase().replace(/[\s.]/g, '');
}

/** Format valide ? FR = strict ; autres = format par pays (repli générique UE). Vide = considéré valide (champ optionnel). */
export function isValidVatFormat(input: string | null | undefined): boolean {
    const vat = normalizeVat(input);
    if (!vat) {
        return true;
    }
    if (vat.length < 4) {
        return false;
    }
    const pattern = VAT_PATTERNS[vat.slice(0, 2)];
    return pattern ? pattern.test(vat) : GENERIC_EU_VAT.test(vat);
}

/** SIREN (9 chiffres) extrait d'une TVA FR valide, sinon null. Sert à chercher l'entreprise dans Sirene. */
export function deriveSirenFromFrVat(input: string | null | undefined): string | null {
    const vat = normalizeVat(input);
    return VAT_PATTERNS.FR.test(vat) ? vat.slice(4) : null;
}
